<p-toast />
<app-main-header></app-main-header>
<app-toolbar
    pageTitle="Portal Administration"
    pageSubTitle="Select a Service to Manage"></app-toolbar>
<main class="container py-4">
    <app-block-grid>
        <div class="col-12 mb-3" >
            <p-message severity="info" styleClass="w-full" *ngIf="auth().user?.otpMeans === 'None'">
                <div class="flex flex-column">
                    <div class="font-bold text-lg">Enhance your account security</div>
                    <p routerLink="/user/settings/setup-passkey" class="text-primary cursor-pointer">
                        Set up passkey authentication in your user settings 
                    </p>
                </div>
            </p-message>
        </div>
        <div class="grid">
            <div *ngFor="let card of cards" class="col-12 sm:col-12 md:col-6 lg:col-4 xl:col-4">
                <!-- <p-blockui [target]="pnl" [blocked]="card.disabled" /> -->
                <p-card
                    styleClass="card-shadow shadow-2 border-1 cursor-pointer border-gray-400 h-100 hover:border-primary w-full"
                    [class.disabled-card]="card.disabled"
                    (click)="openServiceAdmin(card.route)">
                    <div class="flex align-items-center">
                        <!-- Left Image -->
                        <div class="w-5rem h-5rem md:w-7rem md:h-7rem border-round-lg mr-3">
                            <i class="pi {{ card.icon }} text-4xl md:text-6xl p-4"></i>
                        </div>
                        <!-- <img [src]="card.image" alt="Card Image"
                            class="w-5rem h-5rem md:w-7rem md:h-7rem border-round-lg mr-3" /> -->
                        <!-- Text Content -->
                        <div class="flex flex-column align-items-start justify-content-center">
                            <h2 class="card-title mb-2">{{ card.header }}</h2>
                            <p class="card-subtitle mt-1">{{ card.subheader }}</p>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    </app-block-grid>
</main>
<app-footer></app-footer>
